import { useState, useEffect } from "react";

function getStorageValue<T>(key: string, defaultValue: T) {
  const saved = localStorage.getItem(key);
  const value = saved === null ? defaultValue : JSON.parse(saved);
  return value;
}

function useLocalStorage<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}

export default useLocalStorage;
